<div class="main-content-container">
  <div class="main-container-body">
    <div class="page-title-container d-flex">
      @if (!utilService.isMobile()) {
        <div class="page-title flex-grow-1 ng-star-inserted">
          <div class="mb-0 ng-star-inserted">
            <div class="d-flex align-items-center">
              @if (showbackButton) {
                <div class="pl-2 pr-2 ng-star-inserted"><a class="d-inline-flex"
                  (click)="previous()" href="javascript:void(0)"><img
                src="assets/images/grid-back.png"></a>
              </div>
            }
            <div class="text-capitalize"> {{_resourceDef.page_name.view | translate | async}} </div>
          </div>
        </div>
      </div>
    }
  </div>
  <div class="main-container-body main-box-shadow">
    @if (_resourceDef && result) {
      <dhs-form-view [fieldGroup]="_resourceDef.form" [data]="result">
      </dhs-form-view>
    }
  </div>
</div>
</div>